module.exports = __webpack_public_path__ + "img/chatbot.0a65eac7.png";